// Cross-browser-safe drag-and-drop data helpers.
//
// Why this exists: older browsers (IE10/11, some legacy Edge/Safari) restrict
// dataTransfer in ways that break a naive setData/getData with a custom MIME
// type:
//   - setData/getData with a custom type like "application/x-workflow-template"
//     can THROW in IE (only "Text"/"URL" are allowed there).
//   - reading dataTransfer.types during dragover may be a DOMStringList, not an
//     Array, so .indexOf isn't guaranteed.
//
// These helpers wrap every access in try/catch and always also write a
// "text/plain" copy as a fallback, so a drag that can't carry the custom type
// still survives. All drag/drop sites should go through here.

var TEMPLATE_TYPE = 'application/x-workflow-template';
var FLOW_TYPE = 'application/x-workflow-flow';
// Plain-text fallback channel. We prefix values so a fallback read can tell a
// template id apart from a flow payload when the custom type was unavailable.
var TEXT_TYPE = 'text/plain';
var TEXT_PREFIX = 'wf:';

// Write a value under a custom type, with a text/plain fallback. Never throws.
function setData(dataTransfer, type, value) {
  if (!dataTransfer) return;
  try { dataTransfer.setData(type, value); } catch (err) { /* custom type rejected */ }
  try { dataTransfer.setData(TEXT_TYPE, TEXT_PREFIX + type + '|' + value); } catch (err) {}
}

// Read a value for a custom type, falling back to the text/plain channel if the
// custom type couldn't be read (or was never stored). Returns '' when absent.
function getData(dataTransfer, type) {
  if (!dataTransfer) return '';
  var direct = '';
  try { direct = dataTransfer.getData(type) || ''; } catch (err) { direct = ''; }
  if (direct) return direct;

  var text = '';
  try { text = dataTransfer.getData(TEXT_TYPE) || ''; } catch (err) { text = ''; }
  if (text.indexOf(TEXT_PREFIX + type + '|') === 0) {
    return text.slice((TEXT_PREFIX + type + '|').length);
  }
  return '';
}

// True if the drag carries the given custom type. Checks dataTransfer.types
// (handling DOMStringList vs Array) and also the text/plain fallback marker,
// since during dragover the custom type may be hidden but text/plain is exposed.
function hasType(dataTransfer, type) {
  if (!dataTransfer) return false;
  var types = dataTransfer.types || [];
  for (var i = 0; i < types.length; i += 1) {
    if (types[i] === type) return true;
  }
  // Fallback: the text/plain channel is the only readable type in some browsers
  // during dragover. We can't read its value yet (security), but if text/plain
  // is present we optimistically allow the drop and validate on drop.
  for (var j = 0; j < types.length; j += 1) {
    if (types[j] === TEXT_TYPE) return true;
  }
  return false;
}

module.exports = {
  TEMPLATE_TYPE: TEMPLATE_TYPE,
  FLOW_TYPE: FLOW_TYPE,
  setData: setData,
  getData: getData,
  hasType: hasType
};
